<button class="border-{{summary.class || 'light'}} text-{{summary.class}}"
  [ngClass]="{'border-thick' : isSelected}"
  role="button"
  (click)="click()">
  <div class="space-between align-center">
    <div>
      <h3 [innerHTML]="summary.name | translate"></h3>
      @if (summary.count !== undefined || summary.total) {
        <h2>
          @if (summary.count !== undefined) {
            <span
            [innerHTML]="summary.count"></span>
          }
          @if (summary.count && summary.total) {
            <span
            class="p-15"> / </span>
          }
          @if (summary.total) {
            <span
              [innerHTML]="summary.total"
            class="p-15"></span>
          }
        </h2>
      }
    </div>
    @if (summary.iconName) {
      <sb-icon
        [name]="summary.iconName"
      overrideStyle="regular"></sb-icon>
    }
  </div>
  @if (summary.total) {
    <div class="summary__progress"
      >
      <ngb-progressbar [type]="summary.class"
        [value]="(summary.count / summary.total) * 100"
      height="10px"></ngb-progressbar>
    </div>
  }
</button>